"use client";
import { Icon } from "@/components/icon";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import ReactSelect from "react-select";
import { FormPlaceHolder } from "../form-placeholder";
import { ISelect } from "./select.types";

export const Select: ISelect = ({
  options,
  label,
  onSelect,
  defaultValue,
  className,
  required,
  value,
  error,
  wrapperClassName,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  const ref = useRef<any>(null);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!value) {
      ref.current?.clearValue();
    }
  }, [value]);

  if (!isMounted) {
    return null; // Or a placeholder while client-side rendering occurs
  }
  return (
    <div className={classNames("relative", wrapperClassName, { "border-error": !!error, "border-2": !!error })}>
      <ReactSelect
        aria-label={label}
        value={value}
        placeholder={null}
        isClearable
        isSearchable={false}
        ref={ref}
        className={className}
        defaultValue={defaultValue}
        onChange={onSelect}
        options={options as any}
        classNames={{
          placeholder: () => "select-placeholder",
          menu: () => "select-menu",
          container: (props) =>
            classNames("select-container", {
              "select-container-focused": props.isFocused,
            }),
          control: (props) =>
            classNames("select-control", {
              "select-control-focused": props.isFocused || !!value,
              "select-control-with-label": !!label,
              "select-control-with-label-focused": !!label && (props.isFocused || !value),
            }),
          singleValue: () => "select-single-value",
          option: () => "select-option",
        }}
        components={{
          SelectContainer: ({ children, isFocused }) => (
            <div className="select-container relative">
              <FormPlaceHolder
                focused={isFocused || !!value}
                label={label}
                required={required}
                error={error}
              />
              {children}
            </div>
          ),
          Option: ({ children, innerProps }) => (
            <div
              {...innerProps}
              className="select-option"
            >
              {children}
            </div>
          ),
          ValueContainer: ({ children }) => <div className="relative flex flex-row items-center">{children}</div>,
          IndicatorsContainer: ({}) => (
            <Icon
              className="select-arrow"
              name="arrowDown"
            />
          ),
        }}
        styles={{
          indicatorSeparator: () => ({ display: "none" }),
          menuList: (base) => ({
            ...base,
            padding: 0,
            overflow: "visible",
          }),
          menuPortal: (base) => ({
            ...base,
          }),
        }}
        menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
        menuPosition="fixed"
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary75: "red",
          },
        })}
      />
      {error && <span className="form-error">{error}</span>}
    </div>
  );
};
